<template>

	<div class="dropdown-item">
		<div class="dropdown-intro" >
      <DrowdownLine :is-expanded="isExpanded" :cb="toggleExpanded">
        <b>Reactie {{ name }}</b>
			</DrowdownLine>

			<Collapse :when="isExpanded" :baseHeight="120" class="dropdown-expanded-text">
				<div v-html="item"></div>
			</Collapse>
		</div>
	</div>
</template>

<script setup>
  import { defineProps, reactive, ref, watch } from "vue";
  import { Collapse } from 'vue-collapsed';
	import { useStore } from 'vuex';

	const store = useStore()

  watch(() => store.getters.selectedCompanyName, function() {
    isExpanded.value = false;
   });

  import DrowdownLine from '@/story/risicos/dropdown-line.vue';

  const props = defineProps({
    name: String,
    item: String,
    maxCount: Number
  });

  function truncateString(s, wordCount) {
    var expr = new RegExp("(([^\\s]+\\s+){" + wordCount + "}).+");
    return s.replace(expr, "$1");
  }

  function countWords(str) {
    return str.trim().split(/\s+/).length;
  }

  let count = countWords(props.item);
  const shouldExpand = ref(false);
  let t = String(props.item);

  if (count > props.maxCount) {
    shouldExpand.value = true;
    t = truncateString(props.item, props.maxCount);
  }

  const teaser = ref(t);
  const isExpanded = ref(false);
  const toggleExpanded = () => {
    isExpanded.value = !isExpanded.value;
  }
</script>

<style lang="scss" scoped>
	.dropdown-item {
		background: var(--lightblue);
		padding: 2rem;

    .dropdown-expanded-text {
      margin-top: 2rem;
    }

    .title {
      margin-bottom: 0;
    }

    a, a:visited, a:hover {
      color: var(--moss) !important;
    }
	}

</style>